import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import tags from '../../components/ui-components/tags/tags';
import Card from '@components/ui-components/card/component.js';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import LoadMore from '@components/ui-components/load-more/load-more';
import Pagination from '@components/ui-components/pagination/pagination.vue';
import { mapState } from "vuex";
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            pagination: null,
            disableLoadMore: false,
            newNews: []
        }
    },
    components: {
        'tags-cmp': tags,
        'card-cmp': Card,
        'load-more-cmp': LoadMore,
        'pagination-cmp': Pagination,
    },
    computed: {
        ...mapState('mobile', ['isMobile', 'isTablet']),
    },
    methods: {
        setPagination() {
            setTimeout(() => {
                this.pagination = this.$root.convertTwigToJs("pagination", ".js-pagination-news");
            }, 100)
        },
        scrollToContainer() {
            let top = this.$refs.container.getBoundingClientRect().bottom +
                window.pageYOffset - document.querySelector('header').clientHeight - 24;
            window.scrollTo({
                top: top,
                behavior: "smooth"
            });
        }
    },
    mounted() {
        this.setPagination();
    },
    beforeRouteUpdate(to, from, next) {
        // если не loadMore
        if (!to.query.loadMore) {
            const path = to.path.replace(router.history.base, '');
            this.$root.setDataAnimateFalse();

            Vue.http.get(`templates${path}`, { params: to.query }).then(
                (data) => {
                    next();
                    setTimeout(() => {
                        this.template = data.data;
                        this.setPagination();
                        this.newNews = [];
                        onScrollAnimate();
                        this.scrollToContainer();
                    }, 500);
                },
                () => {
                    next('/404');
                }
            );
        } else {
            this.disableLoadMore = true;
            let url = (process.env.NODE_ENV !== 'production') ?
                'news/index.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, { params: to.query }).then(
                (data) => {
                    next();
                    this.newNews = this.newNews.concat(data.data.items);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 10);
                },
                () => {
                    this.disableLoadMore = false;
                    next('/404');
                }
            );
        }
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/news/index.js